import { useWindowSize } from '@folklore/hooks';
import { useEffect, useState } from 'react';

interface VisualViewportState {
    width?: number;
    height?: number;
    offsetTop?: number;
    offsetLeft?: number;
    pageTop?: number;
    pageLeft?: number;
}

// Same as useVisualViewport from @folklore/hooks, with a `disabled` option: each visual
// viewport event renders the component (on mobile, when the address bar shows or hides), so
// the timeline pages that are not current do not subscribe.
function useVisualViewport({ disabled = false }: { disabled?: boolean } = {}) {
    const { width: windowWidth, height: windowHeight } = useWindowSize();
    const [viewport, setViewport] = useState<VisualViewportState>({});

    useEffect(() => {
        const { visualViewport = null } = window;
        if (disabled || visualViewport === null) {
            return () => {};
        }
        function onUpdate() {
            const { width, height, offsetTop, offsetLeft, pageTop, pageLeft } = visualViewport;
            setViewport({ width, height, offsetTop, offsetLeft, pageTop, pageLeft });
        }
        onUpdate();
        visualViewport.addEventListener('resize', onUpdate);
        visualViewport.addEventListener('scroll', onUpdate);
        return () => {
            visualViewport.removeEventListener('resize', onUpdate);
            visualViewport.removeEventListener('scroll', onUpdate);
        };
    }, [disabled]);

    const { width = 0, height = 0, ...otherViewport } = viewport;
    return {
        width: width || windowWidth,
        height: height || windowHeight,
        ...otherViewport,
    };
}

export default useVisualViewport;
